import React, {Component} from 'react';
import {Header, Modal, Progress,Button} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import {REPORT_ACTIONS_API_URL} from "../../constants/api_routes";
import Loader from "../universal/loader";


class ImageUploadProgress extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: true,
            uploadedCount: 0,
            totalCount: 0,
            modalOpen: false,
            errors: [],
            showSuccess: false
        }
    }

    componentWillMount() {
        const totalImages = this.props.mediaAttachments ? this.props.mediaAttachments.length : 0;
        const Images = this.props.mediaAttachments;
        this.setState({totalCount: totalImages, modalOpen: this.props.openModal,isSaving:true});
        if (totalImages > 0) {
            for (let i = 0; i < totalImages; i++) {
                if (Images[i].file) {
                    const formData = new FormData();
                    formData.append("id", Images[i].id);
                    formData.append("file", Images[i].file);
                    if(Images[i].additionalImgId){formData.append("additionalImgId", Images[i].additionalImgId);}
                    this.props.uploadImages(formData, this.successCallback);
                }
            }
        }
        else {
            this.props.resetReportUpdateObject(true);
            setTimeout(() => {
                this.props.completeUpload(false)
            }, 1000)
        }
    }

    successCallback = async (response, image) => {
        let uploadedCount = this.state.uploadedCount;
        uploadedCount = uploadedCount + 1;
        this.setState({uploadedCount: uploadedCount});
        if (!response.success) {
            this.state.errors.push([response.statusMessage,image]);
        }
        if (uploadedCount === this.state.totalCount) {
            await this.setState({isSaving:false});
            this.props.resetReportUpdateObject(true);
            if(this.state.errors.length < 1){
                setTimeout(() => {
                    this.props.completeUpload(false);
                    this.props.getReportById(REPORT_ACTIONS_API_URL, this.props.reportDetails['id']);
                }, 3000)
            }
        }
    };

    retryImageUpload = async () => {
        const totalImages = this.state.errors ? this.state.errors.length : 0;
        const Images = [...this.state.errors];
        this.setState({totalCount: totalImages,uploadedCount:0,errors:[], modalOpen: this.props.openModal,isSaving:true});
        if (totalImages > 0) {
            for (let i = 0; i < totalImages; i++) {
                if (Images[i][1]) {
                await this.props.uploadImages(Images[i][1], this.successCallback);
                }
            }
        }
        else {
            this.props.resetReportUpdateObject(true);
            setTimeout(() => {
                this.props.completeUpload(false);
                this.props.getReportById(REPORT_ACTIONS_API_URL, this.props.reportDetails['id']);
            }, 1000)
        }
    }
    render() {
        return (<div>
            <Modal open={this.state.modalOpen} basic size='small'>
                <Header icon='upload' content='Uploading Report Body and Attachments'/>
                <Modal.Content>
                    <p>
                        Report content and Images are being uploaded.PLEASE WAIT. DO NOT CLOSE THE WINDOW.
                    </p>
                    {this.state.totalCount > 0 &&
                    <Progress value={this.state.uploadedCount} total={this.state.totalCount} progress='ratio'
                              active={this.state.active} color="green"/>}
                    {this.state.showSuccess && <p>Successfully Saved!</p>}
                    {this.state.isSaving && <Loader save={true} contain={true}/>}
                    {this.state.errors.length > 0 && <div>
                        <p>Total Errors in uploading Images: {this.state.errors.length}</p>
                        <div className="pad-all center-aligned">
                        <Button primary content="Click to Retry Failed Uploads" onClick={() =>{this.retryImageUpload()}}/>
                        <Button negative content="Click to Close the window" onClick={(e) => { this.setState({ isSaving: false }); this.props.resetReportUpdateObject(true); this.props.completeUpload(false); this.props.getReportById(REPORT_ACTIONS_API_URL, this.props.reportDetails['id']);}}/>
                        </div>
                        <ol>
                            {this.state.errors.map((error) => {
                            return (<li>{error[0].response&&error[0].response.data.error?error[0].response.data.error:error[0].message}</li>);
                            })}
                        </ol>
                    </div>}
                </Modal.Content>
            </Modal>
        </div>);
    }

}

export default ReportContainer(ImageUploadProgress);


// WEBPACK FOOTER //
// ./src/views/report/image_upload.js